export const Footer = () => {
  return (
    <footer className="border-t border-white/5 py-10 px-4 sm:px-6 lg:px-8" data-testid="site-footer">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          <img src="/assets/cyrion-logo.png" alt="Cyrion" className="w-8 h-8 rounded-md object-cover ring-1 ring-gold/20" />
          <div>
            <p className="font-display font-bold tracking-[0.2em] text-xs text-slate-200">CYRION</p>
            <p className="font-mono text-[10px] text-slate-500">Sovereign wallet · {new Date().getFullYear()}</p>
          </div>
        </div>
        <p className="font-mono text-[10px] tracking-[0.18em] uppercase text-slate-600 text-center">
          Not your keys, not your coins. Your keys, your Cyrion.
        </p>
        <p className="font-mono text-[10px] tracking-[0.18em] uppercase text-slate-700">
          Sovereign by design
        </p>
      </div>
    </footer>
  );
};
